export function SkipLink({ href = '#main-content' }: { href?: string }) {
  return (
    <a href={href} className="skip-link" tabIndex={0}>
      Skip to main content
    </a>
  )
}
